import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16dc69f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "face-detail__header column items-center q-pa-sm bg-grey-2"
}
const _hoisted_2 = {
  key: 2,
  class: "text-body1 text-weight-medium q-mt-sm"
}
const _hoisted_3 = { class: "text-caption text-grey-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    ref: "modal",
    title: "Face",
    size: "xs",
    onHide: _ctx.onHide
  }, {
    actions: _withCtx(({ hide }) => [
      (_ctx.showViewPerson && _ctx.face && _ctx.face.person)
        ? (_openBlock(), _createBlock(_component_q_btn, {
            key: 0,
            icon: "fa fa-user",
            label: "View Person",
            color: "primary",
            flat: "",
            dense: "",
            "no-caps": "",
            onClick: _ctx.viewPerson
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_q_space),
      _createVNode(_component_q_btn, {
        label: "Close",
        flat: "",
        onClick: hide
      }, null, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      (_ctx.face)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.face.imageUrl)
              ? (_openBlock(), _createBlock(_component_q_img, {
                  key: 0,
                  src: _ctx.face.imageUrl,
                  ratio: 1,
                  fit: "cover",
                  class: "face-detail-card__image rounded-borders"
                }, null, 8, ["src"]))
              : (_openBlock(), _createBlock(_component_q_icon, {
                  key: 1,
                  name: "fa fa-user-circle",
                  size: "120px",
                  color: "grey-5"
                })),
            (_ctx.face.person)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.face.person.label || 'Unnamed Person'), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, _toDisplayString(Math.round(_ctx.face.confidence)) + "% confidence ", 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onHide"]))
}